<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Filtro de Mobilidades</h1>

    <b-row>

      <div class="col-sm-1">
        <div class="form-check">
          <input class="form-check-input" type="radio" v-model="filtro.recuperar_destino" name="gridRadios" id="gridRadios1" value="0" checked>
          <label class="form-check-label" for="gridRadios1">
            Origem
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" v-model="filtro.recuperar_destino" name="gridRadios" id="gridRadios2" value="1">
          <label class="form-check-label" for="gridRadios2">
            Destino
          </label>
        </div>
      </div>

      <div class="col-sm-3">
        <SGPFormSelectComponent
          name="ctrl_tarefa_id"
          v-model="filtro.ctrl_tarefa_id" 
          placeholder="Tarefa"
          data-vv-as="Tarefa"
          :optionSelecione="'Selecione'"
          :listaDeOptions="listaDeTarefasAtivasFiltrada"
          optionValue="id"
          optionLabel="tarefa"
          v-validate="'required'"
          :error="validationErrors.first('ctrl_tarefa_id')"
        />
      </div>

      <div class="col-sm-2 container-botoes">
        <button class="mdn-Button mdn-Button--primary" type="submit" @click="filtrarMobilidadesDestino">
          Filtrar
        </button>
      </div>
    </b-row>
    
    <SGPTabelaComponent
      v-if="listaDeMobilidadesTarefaOrigem.length"
      :colunas="colunas"
      :dados="listagem"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :somenteLeitura="true"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      @sgpTabelaModalCadastrarEmit="cadastrarTarefaMobilidade"
    ></SGPTabelaComponent>

    <SGPLoadingComponent v-if="loadingTarefasMobilidades" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TarefasMobilidadesFiltros',

  data () {
    return {
      filtro: {
        ctrl_tarefa_id: null,
        recuperar_destino: 0
      }
    }
  },

  computed: {
    ...mapGetters('ctrlTarefas', ['listaDeTarefasAtivas','loadingTarefas']),
    ...mapGetters('ctrlTarefasMobilidades', ['listaDeMobilidadesTarefaOrigem', 'loadingTarefasMobilidades']),

    listagem(){
      return this.listaDeMobilidadesTarefaOrigem
          .map(item => {
            item.redirecionar = `/workflow/tarefas-mobilidades-metodos/${item.id}`;
            return item;
          });
    },

    listaDeTarefasAtivasFiltrada () {
      return this.listaDeTarefasAtivas.filter(tarefa => tarefa.deleted_at === null)
    },

    colunas () {
      return [
        {
          key: 'ctrl_tarefas.map',
          label: 'MAP',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_origem.tarefa',
          label: 'Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_tipo_tarefa.tipo',
          label: 'Tipo Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_conclusao.conclusao',
          label: 'Tipo Conclusão',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_destino.tarefa',
          label: 'Tarefa Destino',
          sortable: false
        },
        {
          key: 'redirecionar',
          label: 'Associar Métodos',
          sortable: false,
          align: 'center'
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTarefas', [
      'listarTarefasComFiltro',
    ]),

    ...mapActions ('ctrlTarefasMobilidades', [
      'recuperarMobilidadeTarefaOrigem'
    ]),

    filtrarMobilidadesDestino () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.recuperarMobilidadeTarefaOrigem(this.filtro);
        }
      });
    } 

  }
}
</script>